import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";

interface Props {
	tagList: {code: string; name: string}[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const TransportationComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const airListData = dataStr?.replaceAll("|", "").split("^") || [];
	const airList = [];
	for (let i = 0; i < airListData.length; i += 2) {
		const code = airListData[i];
		const name = airListData[i + 1];
		airList.push({code, name});
	}

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="airline-ALL"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={JSON.stringify({code: "ALL", name: "전체"})}
				/>
				<label htmlFor="airline-ALL">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{airList.map((air, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`airline-${air.code}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.some(e => e.code === air.code)}
						value={JSON.stringify({...air})}
					/>
					<label htmlFor={`airline-${air.code}`}>
						<span>{air.name}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const Transportation = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter Transportation Error">
		<TransportationComponent {...props} />
	</ErrorBoundary>
);

export default Transportation;
